import { DateTime } from 'luxon';

export default function initializeTimeRange() {
  const today = DateTime.now(); // Current date
  const currentYear = today.year;
  const currentMonth = today.month;

  let startOfSeason;
  let endOfSeason;

  // Define the current or upcoming season
  if (currentMonth >= 10) {
    startOfSeason = DateTime.fromObject({
      year: currentYear,
      month: 10,
      day: 1,
    });
    endOfSeason = DateTime.fromObject({
      year: currentYear + 1,
      month: 5,
      day: 31,
    });
  } else if (currentMonth <= 5) {
    startOfSeason = DateTime.fromObject({
      year: currentYear - 1,
      month: 10,
      day: 1,
    });
    endOfSeason = DateTime.fromObject({ year: currentYear, month: 5, day: 31 });
  } else {
    startOfSeason = DateTime.fromObject({
      year: currentYear - 1,
      month: 10,
      day: 1,
    });
    endOfSeason = DateTime.fromObject({ year: currentYear, month: 5, day: 31 });
  }

  // Check if today falls within the current season
  const isTodayInSeason = today >= startOfSeason && today <= endOfSeason;

  // If today is not in season, calculate the days until the next season
  let daysUntilNextSeason = 0;
  if (!isTodayInSeason) {
    const nextSeasonStart = DateTime.fromObject({
      year: currentYear,
      month: 10,
      day: 1,
    });
    daysUntilNextSeason = nextSeasonStart.diff(today, 'days').days;
  }

  return {
    start: startOfSeason.toMillis(),
    end: endOfSeason.toMillis(),
    isTodayInSeason,
    daysUntilNextSeason, // Return the days until next season
  };
}
